var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/permissions.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"row\">\r\n    <div class=\"col col-xs-12 col-sm-6 col-md-4\">\r\n        <!--Not very clean, fix setupCustomEnv with renderOptions.customButtons-->\r\n        <div class=\"action-bar sticky-div\">\r\n            <div class=\"buttons\">\r\n                <button class=\"button button-default\" data-window-event=\"savePermissions:";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"inputVars")),"tableName"), env.opts.autoescape);
output += ":";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"inputVars")),"roleID"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Save"), env.opts.autoescape);
output += "</button>\r\n                <button class=\"button button-default\" data-window-event=\"cancelTreeView\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Cancel"), env.opts.autoescape);
output += "</button>\r\n            </div>\r\n        </div>\r\n        <div class=\"content\">\r\n            <form data-form-id=\"FormPermissions\">\r\n                <div class=\"tree-view\">\r\n                ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"FormPermissionMenu");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("branch", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\r\n                <div class=\"branch\">\r\n                    <div class=\"branch-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"Text"), env.opts.autoescape);
output += "</div>\r\n                    <div class=\"branches\">\r\n                        ";
frame = frame.push();
var t_7 = runtime.memberLookup((t_4),"children");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("branch2", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\r\n                        <div class='branch ";
output += runtime.suppressValue(((runtime.memberLookup((t_8),"Collapsed"))?"collapsed":""), env.opts.autoescape);
output += "'>\r\n                            <div class=\"branch-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"Text"), env.opts.autoescape);
output += "</div>\r\n                            <div class=\"branches\">\r\n                                ";
frame = frame.push();
var t_11 = runtime.memberLookup((t_8),"children");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("branch3", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\r\n                                <div class=\"stick\">\r\n                                    <label class=\"table-cell field checkbox\">\r\n                                        <input name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_12),"ID"), env.opts.autoescape);
output += "\" type=\"checkbox\" ";
output += runtime.suppressValue(((runtime.memberLookup((t_12),"Available"))?"checked":""), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"IsReadOnly")?"disabled":""), env.opts.autoescape);
output += " ";
if(runtime.memberLookup((t_12),"IsReadOnly")) {
output += " style=\"visibility: hidden\" ";
;
}
output += ">\r\n                                        <span data-window-event=\"selectPermissions:";
output += runtime.suppressValue(runtime.memberLookup((t_12),"TableName"), env.opts.autoescape);
output += ":";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"RoleID"), env.opts.autoescape);
output += ":";
output += runtime.suppressValue(runtime.memberLookup((t_4),"Text"), env.opts.autoescape);
output += ";";
output += runtime.suppressValue(runtime.memberLookup((t_8),"Text"), env.opts.autoescape);
output += ";";
output += runtime.suppressValue(runtime.memberLookup((t_12),"Text"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"Text"), env.opts.autoescape);
output += "</span>\r\n                                    </label>\r\n                                </div>\r\n                                ";
if(runtime.memberLookup((t_12),"children")) {
output += "\r\n                                <div class='branch ";
output += runtime.suppressValue(((runtime.memberLookup((t_12),"Collapsed"))?"collapsed":""), env.opts.autoescape);
output += "'>\r\n                                    <div class=\"branch-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"Text"), env.opts.autoescape);
output += "</div>\r\n                                    <div class=\"branches\">\r\n                                        ";
frame = frame.push();
var t_15 = runtime.memberLookup((t_12),"children");
if(t_15) {var t_14 = t_15.length;
for(var t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13];
frame.set("branch4", t_16);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
output += "\r\n                                            <div class=\"stick\"> \r\n                                                <label class=\"table-cell\">\r\n                                                    ";
if(!runtime.memberLookup((t_16),"IsReadOnly")) {
output += "\r\n                                                        <input name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_16),"ID"), env.opts.autoescape);
output += "\" type=\"checkbox\" ";
output += runtime.suppressValue(((runtime.memberLookup((t_16),"Available"))?"checked":""), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"IsReadOnly")?"disabled":""), env.opts.autoescape);
output += ">\r\n                                                    ";
;
}
output += "\r\n                                                    <span data-window-event=\"selectPermissions:";
output += runtime.suppressValue(runtime.memberLookup((t_16),"TableName"), env.opts.autoescape);
output += ":";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"RoleID"), env.opts.autoescape);
output += ":";
output += runtime.suppressValue(runtime.memberLookup((t_4),"Text"), env.opts.autoescape);
output += ";";
output += runtime.suppressValue(runtime.memberLookup((t_8),"Text"), env.opts.autoescape);
output += ";";
output += runtime.suppressValue(runtime.memberLookup((t_12),"Text"), env.opts.autoescape);
output += ";";
output += runtime.suppressValue(runtime.memberLookup((t_16),"Text"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_16),"Text"), env.opts.autoescape);
output += "</span>\r\n                                                </label>\r\n                                            </div>\r\n                                        ";
;
}
}
frame = frame.pop();
output += "\r\n                                    </div>\r\n                                </div>\r\n                                ";
;
}
output += "\r\n                                ";
;
}
}
frame = frame.pop();
output += "\r\n                            </div>\r\n                        </div>\r\n                        ";
;
}
}
frame = frame.pop();
output += "\r\n                    </div>\r\n                </div>\r\n                ";
;
}
}
frame = frame.pop();
output += "\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-xs-12 col-md-8 col-sm-6 panel left-border\">\r\n        ";
if(!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"ActionInfo")),"length") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"ColumnInfo")),"length") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"TabInfo")),"length")) {
output += "\r\n        <!--Nothing to display, maybe some informative text-->\r\n        ";
;
}
else {
output += "\r\n        <div class=\"breadcrumbs\">\r\n            ";
frame = frame.push();
var t_19 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"breadCrumbs");
if(t_19) {var t_18 = t_19.length;
for(var t_17=0; t_17 < t_19.length; t_17++) {
var t_20 = t_19[t_17];
frame.set("b", t_20);
frame.set("loop.index", t_17 + 1);
frame.set("loop.index0", t_17);
frame.set("loop.revindex", t_18 - t_17);
frame.set("loop.revindex0", t_18 - t_17 - 1);
frame.set("loop.first", t_17 === 0);
frame.set("loop.last", t_17 === t_18 - 1);
frame.set("loop.length", t_18);
output += "\r\n            <div class=\"crumb\">";
output += runtime.suppressValue(t_20, env.opts.autoescape);
output += "</div>\r\n            ";
;
}
}
frame = frame.pop();
output += "\r\n        </div>\r\n        <div class=\"content\">\r\n            <h3>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Buttons"), env.opts.autoescape);
output += "</h3>\r\n\r\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"ActionInfo") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"ActionInfo")),"length")) {
output += "\r\n            <form class=\"clearfix\" data-form-id=\"Actions\">\r\n\t\t\t\t";
frame = frame.push();
var t_23 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"ActionInfo");
if(t_23) {var t_22 = t_23.length;
for(var t_21=0; t_21 < t_23.length; t_21++) {
var t_24 = t_23[t_21];
frame.set("x", t_24);
frame.set("loop.index", t_21 + 1);
frame.set("loop.index0", t_21);
frame.set("loop.revindex", t_22 - t_21);
frame.set("loop.revindex0", t_22 - t_21 - 1);
frame.set("loop.first", t_21 === 0);
frame.set("loop.last", t_21 === t_22 - 1);
frame.set("loop.length", t_22);
output += "\r\n\t\t\t\t\t<div style=\"float: left;\">\r\n\t\t\t\t\t\t<label class=\"button button-menu check-button\"><input type=\"checkbox\" name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_24),"ActionName"), env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue(((runtime.memberLookup((t_24),"Available"))?"checked":""), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"IsReadOnly")?"disabled":""), env.opts.autoescape);
output += ">";
output += runtime.suppressValue(runtime.memberLookup((t_24),"ActionTitle"), env.opts.autoescape);
output += "</label>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n            </form>\r\n\t\t\t";
;
}
output += "\r\n\r\n            <h3>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Columns"), env.opts.autoescape);
output += "</h3>\r\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"ColumnInfo") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"ColumnInfo")),"length")) {
output += "\r\n            <div class=\"content\">\r\n                <form class=\"table-view bordered\" data-form-id=\"Columns\">\r\n                    <div class=\"table-container\">\r\n                        <div class=\"table-index\">\r\n                            <div class=\"table-row\">\r\n                                <div class=\"table-cell\"><div class=\"ellipsis\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Column"), env.opts.autoescape);
output += "</div></div>\r\n                                <div class=\"table-cell checkbox\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ShowInMulti"), env.opts.autoescape);
output += "\"><div class=\"ellipsis\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ShowInMulti"), env.opts.autoescape);
output += "</div></div>\r\n                                <div class=\"table-cell checkbox\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ShowInSingle"), env.opts.autoescape);
output += "\"><div class=\"ellipsis\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ShowInSingle"), env.opts.autoescape);
output += "</div></div>\r\n                                <div class=\"table-cell checkbox\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ShowInNew"), env.opts.autoescape);
output += "\"><div class=\"ellipsis\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"ShowInNew"), env.opts.autoescape);
output += "</div></div>\r\n                                <div class=\"table-cell checkbox\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Editable"), env.opts.autoescape);
output += "\"><div class=\"ellipsis\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Editable"), env.opts.autoescape);
output += "</div></div>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"table-body\">\r\n                            <div class=\"table-rows\">\r\n\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_27 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"ColumnInfo");
if(t_27) {var t_26 = t_27.length;
for(var t_25=0; t_25 < t_27.length; t_25++) {
var t_28 = t_27[t_25];
frame.set("x", t_28);
frame.set("loop.index", t_25 + 1);
frame.set("loop.index0", t_25);
frame.set("loop.revindex", t_26 - t_25);
frame.set("loop.revindex0", t_26 - t_25 - 1);
frame.set("loop.first", t_25 === 0);
frame.set("loop.last", t_25 === t_26 - 1);
frame.set("loop.length", t_26);
output += "\r\n                                <div class=\"table-row\">\r\n                                    <div class=\"table-cell field\" data-window-event=\"toggle-column:";
output += runtime.suppressValue(runtime.memberLookup((t_28),"ColumnName"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_28),"ColumnTitle"), env.opts.autoescape);
output += "</div>\r\n                                    <label class=\"table-cell field checkbox\"><input name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_28),"ColumnName"), env.opts.autoescape);
output += "[Multi]\" type=\"checkbox\" ";
output += runtime.suppressValue(((runtime.memberLookup((t_28),"Multi"))?"checked":""), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"IsReadOnly")?"disabled":""), env.opts.autoescape);
output += "></label>\r\n                                    <label class=\"table-cell field checkbox\"><input name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_28),"ColumnName"), env.opts.autoescape);
output += "[Single]\" type=\"checkbox\" ";
output += runtime.suppressValue(((runtime.memberLookup((t_28),"Single"))?"checked":""), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"IsReadOnly")?"disabled":""), env.opts.autoescape);
output += "></label>\r\n                                    <label class=\"table-cell field checkbox\"><input name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_28),"ColumnName"), env.opts.autoescape);
output += "[New]\" type=\"checkbox\" ";
output += runtime.suppressValue(((runtime.memberLookup((t_28),"New"))?"checked":""), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"IsReadOnly")?"disabled":""), env.opts.autoescape);
output += "></label>\r\n                                    <label class=\"table-cell field checkbox\"><input name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_28),"ColumnName"), env.opts.autoescape);
output += "[Editable]\" type=\"checkbox\" ";
output += runtime.suppressValue(((runtime.memberLookup((t_28),"Editable"))?"checked":""), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"IsReadOnly")?"disabled":""), env.opts.autoescape);
output += "></label>\r\n                                </div>\r\n\t\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n                            </div>\r\n                        </div>\r\n                    </div>  \r\n                </form> \r\n            </div>\r\n            ";
;
}
output += "\r\n            <h3>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Tabs"), env.opts.autoescape);
output += "</h3>\r\n            <form class=\"clearfix\" data-form-id=\"Tabs\">\r\n\t\t\t\t";
frame = frame.push();
var t_31 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"TabInfo");
if(t_31) {var t_30 = t_31.length;
for(var t_29=0; t_29 < t_31.length; t_29++) {
var t_32 = t_31[t_29];
frame.set("x", t_32);
frame.set("loop.index", t_29 + 1);
frame.set("loop.index0", t_29);
frame.set("loop.revindex", t_30 - t_29);
frame.set("loop.revindex0", t_30 - t_29 - 1);
frame.set("loop.first", t_29 === 0);
frame.set("loop.last", t_29 === t_30 - 1);
frame.set("loop.length", t_30);
output += "\r\n                <div style=\"float: left;\">\r\n                    <label class=\"button button-menu check-button\"><input type=\"checkbox\" name=\"";
output += runtime.suppressValue(runtime.memberLookup((t_32),"ActionName"), env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue(((runtime.memberLookup((t_32),"Available"))?"checked":""), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "custom")),"IsReadOnly")?"disabled":""), env.opts.autoescape);
output += ">";
output += runtime.suppressValue(runtime.memberLookup((t_32),"ActionTitle"), env.opts.autoescape);
output += "</label>\r\n                </div>\r\n\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n            </form>\r\n        </div>\r\n        ";
;
}
output += "\r\n    </div>\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/permissions.html"] , dependencies)